import { createApp } from 'vue'
import App from './App.vue'
import router from './router'


import 'video.js/dist/video-js.css'
import '../src/styles/main.scss'

const app = createApp(App)
app.use(router)

import { Overlay, Image as VanImage, Loading, Toast, Lazyload   } from 'vant';
app.use(Overlay)
app.use(VanImage);
app.use(Loading);
app.use(Toast);
app.use(Lazyload);



app.mount('#app')
